import { Box, Button, Card, Typography } from "@mui/material";
import { executeGameAction } from "api/game/gameActions";
import * as GameCard from "components/pages/game/GameCard";
import { ChooseEffectOptionType } from "models/ChooseEffectOptionType";
import { useSnackbar } from "notistack";
import React from "react";
import { useParams } from "react-router-dom";

export interface Props {
  cardName: string;
  options: ChooseEffectOptionType[];
  description: string;
  optionsAreCards: boolean;
}

export const Component: React.FC<Props> = ({ cardName, options, description, optionsAreCards }) => {
  const { gameId } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const onClick = (option: number) => {
    if (gameId === undefined) {
      console.error("Game ID is undefined");
      return;
    }

    executeGameAction({
      gameId,
      ActionData: {
        option,
      },
      ActionId: "CHOOSE",
      DecisionId: "CHOOSE_CARD_EFFECT",
      enqueueSnackbar,
    });
  };

  const renderCardOptions = () => {
    return (
      <>
        <Typography variant="h6" gutterBottom>
          {description}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {options.map((option) => (
            <GameCard.Component name={option.description} onClick={() => onClick(option.option)} />
          ))}
        </Box>
      </>
    );
  };

  const renderButtonOptions = () => {
    return (
      <>
        <Typography variant="h6" gutterBottom>
          Choose which action for {cardName}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {options.map((option) => (
            <Button
              key={option.option}
              variant="contained"
              onClick={() => onClick(option.option)}
              sx={{ m: 1 }}
            >
              {option.description}
            </Button>
          ))}
        </Box>
      </>
    );
  };

  return (
    <Card
      sx={{
        borderRadius: 0,
        width: "fit-content",
        maxWidth: "100%",
        margin: "auto",
      }}
    >
      <Box sx={{ margin: 2 }}>
        <Typography variant="h5" gutterBottom>
          Choose Card Effect
        </Typography>
        {optionsAreCards ? renderCardOptions() : renderButtonOptions()}
      </Box>
    </Card>
  );
};

Component.displayName = "ChooseCardEffect";
